"use strict";

import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  container: StyleSheet.absoluteFillObject,
  background: {
    backgroundColor: 'white',
    borderRadius: 15
  }
});
//# sourceMappingURL=styles.js.map